import { environment } from "./util.environment.js";
import { makeEnvironmentRef } from "./util.make-environment-ref.js";
import { z } from "zod";
//#region src/env/parser.array.ts
/**
* extract array value directly from an environment variable, wherein items are
* parsed based on the provided itemSchema
*/
function asArray(key, options) {
	return makeEnvironmentRef(() => z.preprocess((input) => !input ? [] : Array.isArray(input) ? input : input.split((options === null || options === void 0 ? void 0 : options.delimiter) ?? ";"), z.array((options === null || options === void 0 ? void 0 : options.itemSchema) ?? z.string())).parse(environment.read(key, options)));
}
//#endregion
export { asArray };

//# sourceMappingURL=parser.array.js.map